var _defs, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1121 266",
    width: 1121,
    height: 266,
    role: "img",
    "aria-label": "IMMO INTEREST \\u2014 Real Estate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 560.5,
    y: 150,
    textAnchor: "middle",
    fontFamily: "PJS, 'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 800,
    fontSize: 128,
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#0B1020"
  }, "IMMO"), /*#__PURE__*/React.createElement("tspan", {
    dx: 34,
    fill: "#FF6A2B"
  }, "INTEREST"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 568.5,
    y: 222,
    textAnchor: "middle",
    fontFamily: "PJS, 'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: 34,
    letterSpacing: 15,
    fill: "#99A1B3"
  }, "REAL ESTATE")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.aa511d929f2c61375d805179bd2539b5.svg";
export { ForwardRef as ReactComponent };